export default "__VITE_ASSET__cc4aa228__"